import React, { PropsWithChildren } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import { ICONS } from '@Const/common'

interface SidebarProps {
    onClose(): void
}

const Sidebar = observer(({ children, onClose }: PropsWithChildren<SidebarProps>) => (
    <div className="sidebar-component">
        <img onClick={onClose} className="close" src={ICONS.close} alt="close" />
        {children}
    </div>
))

export default Sidebar
